<template>
  <section class="package-characteristics">
    <header>Параметры упаковки</header>

    <VInputNumberRusV2
      :layout="layout"
      label="Длина"
      label-width="220px"
      v-model="orderOption.packageLength"
      :type="Dimension"
      :required="required"
      :disabled="disabled"
      :max="1000000"
      unit="мм"
    />

    <VInputNumberRusV2
      :layout="layout"
      label="Ширина"
      label-width="220px"
      v-model="orderOption.packageWidth"
      :type="Dimension"
      :required="required"
      :disabled="disabled"
      :max="1000000"
      unit="мм"
    />

    <VInputNumberRusV2
      :layout="layout"
      label="Высота"
      label-width="220px"
      v-model="orderOption.packageHeight"
      :type="Dimension"
      :required="required"
      :disabled="disabled"
      :max="10000000"
      unit="мм"
    />


    <VInputNumberRusV2
      :layout="layout"
      label-width="220px"
      label="Объем"
      v-model="orderOption.packageCargoVolume"
      :type="Volume"
      disabled
      :max="1000000"
      :min="0.00001"
      :required="required"
      unit="м&sup3;"
    >
      <template #helper-text>
        Укажите высоту, длину и ширину упаковки для автоматического расчёта.
      </template>
    </VInputNumberRusV2>


    <VInputNumberRusV2
      :layout="layout"
      label="Вес Брутто одной упаковки"
      label-width="220px"
      v-model="orderOption.packageWeight"
      :type="Weight"
      :required="required"
      :disabled="disabled"
      :max="100000"
      unit="кг"
    />
  </section>
</template>

<script lang="ts">
import type AbstractOrderOption   from "@/domains/Abstract/AbstractOrderOption";
import type { UnwrapNestedRefs }  from "vue";
import Dimension                  from "@/core/types/Dimension";
import Volume                     from "@/core/types/Volume";
import Weight                     from "@/core/types/Weight";

export default defineComponent({
  name: "PackageCharacteristics",

  props: {
    orderOption: {
      type: Object as PropType<AbstractOrderOption | UnwrapNestedRefs<AbstractOrderOption>>,
      required: true,
    },
    layout: {
      type: String,
      default: "vertical",
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    /** Классы нужны шаблону для :type у VInputNumberRusV2 */
    return {
      Dimension,
      Volume,
      Weight,
    };
  },

});
</script>
